module.exports = __webpack_public_path__ + "img/arrow-down.34e9b0cc.svg";